/* esm.sh - applesauce-core@5.2.0/dist/helpers/factory */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/factory.mjs";
